exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".breadcrumbs[data-v-c32110ec]{display:flex;align-items:center;margin-bottom:8px}@media (min-width:1024px){.breadcrumbs[data-v-c32110ec]{margin-bottom:16px}}.breadcrumbs .breadcrumb[data-v-c32110ec]{font-weight:400;font-size:.875rem;line-height:1.375rem;white-space:nowrap}.breadcrumbs .breadcrumb[data-v-c32110ec],.breadcrumbs .separator[data-v-c32110ec]{--tw-text-opacity:1;color:rgba(174,178,187,var(--tw-text-opacity))}.breadcrumbs .separator[data-v-c32110ec]{padding-left:8px;padding-right:8px}", ""]);

// exports
